import React, { forwardRef } from "react";
import * as SwitchPrimitive from "@radix-ui/react-switch";
import "./radix-styles/Switch.scss";
import Flex from "./Flex";

const Switch = forwardRef(
  (
    {
      id,
      checked,
      onCheckedChange,
      children,
      disabled,
      required,
      size = "large",
    },
    ref
  ) => {
    const rootClassName = `SwitchRoot SwitchRoot-${size}`;

    return children ? (
      <Flex className="CustomSwitch" gap={200} align="center">
        <SwitchPrimitive.Root
          className={rootClassName}
          id={id}
          checked={checked}
          onCheckedChange={onCheckedChange}
          disabled={disabled}
          required={required}
          ref={ref}
          size={size}
          data-component={"switch"}
        >
          <SwitchPrimitive.Thumb className="SwitchThumb" />
        </SwitchPrimitive.Root>
        <label className="Label" htmlFor={id}>
          {children}
        </label>
      </Flex>
    ) : (
      <>
        <SwitchPrimitive.Root
          className={rootClassName}
          id={id}
          checked={checked}
          onCheckedChange={onCheckedChange}
          disabled={disabled}
          ref={ref}
          required={required}
          size={size}
          data-component={"switch"}
        >
          <SwitchPrimitive.Thumb className="SwitchThumb" />
        </SwitchPrimitive.Root>
      </>
    );
  }
);

export default Switch;
